import {
  BarChart3,
  Users,
  Search,
  Newspaper,
  Mail,
  Rocket,
  DollarSign,
  TrendingUp,
  Settings,
  CheckCircle2,
  AlertTriangle,
  XCircle,
  Plus,
  Edit,
  Trash2,
  Save,
  X,
  ChevronRight,
  ChevronLeft,
  Menu,
  Home,
  FileText,
  Image,
  Type,
  Heading,
  Link as LinkIcon,
  Layout,
  MoreVertical,
  Copy,
  Eye,
  EyeOff,
  Download,
  Upload,
  RefreshCw,
  Loader2,
  Sparkles,
  Map,
  Globe
} from 'lucide-react';

// Navigation icons
export const navIcons = {
  dashboard: BarChart3,
  leads: Users,
  scraper: Search,
  articles: Newspaper,
  templates: Mail,
  campaigns: Rocket,
  domains: Globe,
  nurture: Sparkles,
  mqls: DollarSign,
  analytics: TrendingUp,
  settings: Settings,
};

// Status icons
export const statusIcons = {
  success: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
  info: AlertTriangle,
};

// Action icons
export const actionIcons = {
  add: Plus,
  edit: Edit,
  delete: Trash2,
  save: Save,
  cancel: X,
  close: X,
  next: ChevronRight,
  prev: ChevronLeft,
  menu: Menu,
  more: MoreVertical,
  copy: Copy,
  view: Eye,
  hide: EyeOff,
  download: Download,
  upload: Upload,
  refresh: RefreshCw,
  loading: Loader2,
  sparkles: Sparkles,
};

// Content type icons
export const contentIcons = {
  text: Type,
  heading: Heading,
  image: Image,
  link: LinkIcon,
  layout: Layout,
  file: FileText,
  home: Home,
};

// Helper function to get icon component
export function getIcon(category, name) {
  const iconMap = {
    nav: navIcons,
    status: statusIcons,
    action: actionIcons,
    content: contentIcons,
  };
  
  return iconMap[category]?.[name] || null;
}

// Icon component wrapper for easy usage
// Note: This function returns a component, not JSX directly
// Use it like: const IconComp = Icon({ category: 'nav', name: 'dashboard' }); <IconComp />
export function getIconComponent(category, name) {
  return getIcon(category, name);
}

